/*
 * Copyright (c) 2022 E-WIND - Thais Watanabe.
 * All rights reserved.
 */
import React from "react";
import moment from "moment";

import Card from "src/components/cards/Card.react";
import InspectionTypeBadge from "src/components/badges/InspectionTypeBadge.react";

/**
 * The Inspection Info component
 *
 * @author Thais Watanabe
 */
const InspectionInfo = (props) => {
  const { turbineInspection } = props;

  return (
    <Card>
      <table className="min-w-full divide-y divide-gray-200">
        <tbody className="bg-white divide-y divide-gray-200">
          <tr>
            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 w-52">
              発電所号機
            </td>
            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
              {turbineInspection.windTurbine.name}
            </td>
          </tr>
          <tr>
            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
              点検タイプ
            </td>
            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
              <InspectionTypeBadge type={turbineInspection.inspection.type} />
            </td>
          </tr>
          <tr>
            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
              作成日
            </td>
            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
              {moment(turbineInspection.createdAt).format("YYYY-MM-DD")}
            </td>
          </tr>
        </tbody>
      </table>
    </Card>
  );
};

export default InspectionInfo;
